<template>
  <GestionSolicitudesRechazadasZone />

</template>
<script>
import GestionSolicitudesRechazadasZone from "./components/GestionSolicitudesRechazadasZone";
export default {
  name: "SolicitudesRechazadas",
  components: { GestionSolicitudesRechazadasZone }
};
</script>
